import styled from 'styled-components'

import Loading from 'components/base/Loading'

export const CityName = styled.span`
  text-transform: capitalize;
`

export const ConciergeIconLoading = styled(Loading)`
  margin: 25px auto 0 auto;
  left: 5px;
`
